import { createFeatureSelector } from '@ngrx/store';
import { RfisState } from '@rfis/reducers';

export const selectRfisModule = createFeatureSelector<RfisState>('rfis');
